// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand: #007bff;
  --brand-dark: #0056b3;
  --bg: #f5f7fa;
  --text: #333;
  --muted: #666;
}

/* === Общий контейнер === */
.Home_home__9qOJG {
  font-family: "Segoe UI", Tahoma, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 20px 0px;
  height: 100%;
  background: var(--bg);
  color: var(--text);
  /*animation: fadeIn 0.4s ease forwards;*/
}

@keyframes Home_fadeIn__FEyhP {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* === Заголовок === */
.Home_header__PipX\\+ {
  text-align: center;
  margin-bottom: 40px;
}

.Home_header__PipX\\+ h1 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.Home_subtitle__4jY9u {
  font-size: 1rem;
  color: var(--muted);
}

/* === Сетка карточек === */
.Home_rolesGrid__18Qae {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  width: 100%;
  max-width: 1000px;
  padding: 0 10px;
}

/* === Карточка роли === */
.Home_roleCard__JaBcY {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.6rem;
  background: #fff;
  border-radius: 12px;
  padding: 24px 16px;
  color: var(--text);
  text-decoration: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.Home_roleCard__JaBcY:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

/* === Иконка === */
.Home_iconWrapper__6-bNG {
  font-size: 2rem;
  color: var(--brand);
}

/* === Текст карточки === */
.Home_roleInfo__RmGR4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.Home_roleInfo__RmGR4 h3 {
  font-size: 1.1rem;
  margin: 0;
  color: var(--brand-dark);
  font-weight: 600;
}

.Home_roleInfo__RmGR4 p {
  font-size: 0.9rem;
  color: var(--muted);
  margin: 0;
  line-height: 1.3;
  white-space: normal;
  word-break: break-word;
  display: block; /* ✅ всегда показывается */
}

/* === Мобильная адаптация === */
@media (max-width: 768px) {
  .Home_home__9qOJG {
    padding: 60px 16px 40px;
  }

  .Home_header__PipX\\+ h1 {
    font-size: 1.6rem;
  }

  .Home_rolesGrid__18Qae {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .Home_roleCard__JaBcY {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    padding: 16px;
    gap: 14px;
  }

  .Home_iconWrapper__6-bNG {
    font-size: 1.8rem;
    flex-shrink: 0;
  }

  .Home_roleInfo__RmGR4 {
    align-items: flex-start;
    flex: 1 1;
  }

  .Home_roleInfo__RmGR4 h3 {
    font-size: 1rem;
  }

  .Home_roleInfo__RmGR4 p {
    font-size: 0.85rem;
    display: block;
    opacity: 0.95;
    margin-top: 2px;
  }
}

/* === Кнопка входа === */
.Home_loginPrompt__aV0Qs {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.Home_loginButton__UZ7AN {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--brand);
  color: #fff;
  border: none;
  padding: 12px 24px;
  font-size: 1rem;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.25s, transform 0.15s ease;
}

.Home_loginButton__UZ7AN:hover {
  background: var(--brand-dark);
  transform: translateY(-2px);
}
`, "",{"version":3,"sources":["webpack://./src/modules/Base/Home/Home.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc,EAAE,0BAA0B;AAC5C;;AAEA,gCAAgC;AAChC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,SAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B","sourcesContent":[":root {\r\n  --brand: #007bff;\r\n  --brand-dark: #0056b3;\r\n  --bg: #f5f7fa;\r\n  --text: #333;\r\n  --muted: #666;\r\n}\r\n\r\n/* === Общий контейнер === */\r\n.home {\r\n  font-family: \"Segoe UI\", Tahoma, sans-serif;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 0px 20px 0px;\r\n  height: 100%;\r\n  background: var(--bg);\r\n  color: var(--text);\r\n  /*animation: fadeIn 0.4s ease forwards;*/\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; transform: translateY(10px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n/* === Заголовок === */\r\n.header {\r\n  text-align: center;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.header h1 {\r\n  font-size: 2rem;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.subtitle {\r\n  font-size: 1rem;\r\n  color: var(--muted);\r\n}\r\n\r\n/* === Сетка карточек === */\r\n.rolesGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 20px;\r\n  width: 100%;\r\n  max-width: 1000px;\r\n  padding: 0 10px;\r\n}\r\n\r\n/* === Карточка роли === */\r\n.roleCard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 0.6rem;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  padding: 24px 16px;\r\n  color: var(--text);\r\n  text-decoration: none;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\r\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\r\n}\r\n\r\n.roleCard:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n/* === Иконка === */\r\n.iconWrapper {\r\n  font-size: 2rem;\r\n  color: var(--brand);\r\n}\r\n\r\n/* === Текст карточки === */\r\n.roleInfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.roleInfo h3 {\r\n  font-size: 1.1rem;\r\n  margin: 0;\r\n  color: var(--brand-dark);\r\n  font-weight: 600;\r\n}\r\n\r\n.roleInfo p {\r\n  font-size: 0.9rem;\r\n  color: var(--muted);\r\n  margin: 0;\r\n  line-height: 1.3;\r\n  white-space: normal;\r\n  word-break: break-word;\r\n  display: block; /* ✅ всегда показывается */\r\n}\r\n\r\n/* === Мобильная адаптация === */\r\n@media (max-width: 768px) {\r\n  .home {\r\n    padding: 60px 16px 40px;\r\n  }\r\n\r\n  .header h1 {\r\n    font-size: 1.6rem;\r\n  }\r\n\r\n  .rolesGrid {\r\n    grid-template-columns: 1fr;\r\n    gap: 14px;\r\n  }\r\n\r\n  .roleCard {\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n    text-align: left;\r\n    padding: 16px;\r\n    gap: 14px;\r\n  }\r\n\r\n  .iconWrapper {\r\n    font-size: 1.8rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .roleInfo {\r\n    align-items: flex-start;\r\n    flex: 1;\r\n  }\r\n\r\n  .roleInfo h3 {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .roleInfo p {\r\n    font-size: 0.85rem;\r\n    display: block;\r\n    opacity: 0.95;\r\n    margin-top: 2px;\r\n  }\r\n}\r\n\r\n/* === Кнопка входа === */\r\n.loginPrompt {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 200px;\r\n}\r\n\r\n.loginButton {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: var(--brand);\r\n  color: #fff;\r\n  border: none;\r\n  padding: 12px 24px;\r\n  font-size: 1rem;\r\n  border-radius: 8px;\r\n  text-decoration: none;\r\n  transition: background 0.25s, transform 0.15s ease;\r\n}\r\n\r\n.loginButton:hover {\r\n  background: var(--brand-dark);\r\n  transform: translateY(-2px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `Home_home__9qOJG`,
	"header": `Home_header__PipX+`,
	"subtitle": `Home_subtitle__4jY9u`,
	"rolesGrid": `Home_rolesGrid__18Qae`,
	"roleCard": `Home_roleCard__JaBcY`,
	"iconWrapper": `Home_iconWrapper__6-bNG`,
	"roleInfo": `Home_roleInfo__RmGR4`,
	"loginPrompt": `Home_loginPrompt__aV0Qs`,
	"loginButton": `Home_loginButton__UZ7AN`,
	"fadeIn": `Home_fadeIn__FEyhP`
};
export default ___CSS_LOADER_EXPORT___;
